import {html, LitElement} from '@isceco/widget-library2/external/lit/index.js'
import SchweizerkarteLegendeCss from './SchweizerkarteLegendeCss.js'
import i18n from './i18n.json'
import LanguageSwitcher from '@isceco/widget-library2/basic-elements/LanguageSwitcher/LanguageSwitcher.js'

export class SchweizerkarteLegende extends LitElement {

  static get styles() {
    return [SchweizerkarteLegendeCss]
  }

  static get properties() {
    return {}
  }

  connectedCallback() {
    super.connectedCallback()
    // Since we have no properties, requestUpdate is not called
    document.addEventListener(
      LanguageSwitcher.EVENT_KEYS.LANGUAGE_CHANGED,
      () => this.requestUpdate()
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(
      LanguageSwitcher.EVENT_KEYS.LANGUAGE_CHANGED,
      () => this.requestUpdate()
    )
  }

  render() {
    return html`
      <div class="item">
        <p>
          <b>
            ${translateText(i18n, 'mwh')}
          </b>
        </p>
      </div>
      <div class="spacer"></div>
      <div class="item">
        <svg viewBox="0 0 20 20" width="20">
          <path d="M-2297.207-11850.479l11-11"
                transform="translate(2302 11866)"
                stroke="#264d98"
                stroke-linecap="round"
                stroke-width="5"/>
        </svg>
        <p>
          ${translateText(i18n, 'transeuropaeisch')}
        </p>
      </div>
      <div class="item">
        <svg viewBox="0 0 20 20" width="20">
          <path d="M-2297.207-11850.479l11-11"
                transform="translate(2302 11866)"
                stroke="#4ac762"
                stroke-linecap="round"
                stroke-width="3"/>
        </svg>
        <p>
          ${translateText(i18n, 'transportleitung')}
        </p>
      </div>
      <div class="item">
        <svg viewBox="0 0 20 20" width="20">
          <g transform="translate(3 3)"
             fill="#fff"
             stroke="#4ac762"
             stroke-width="3">
            <circle cx="7" cy="7" r="7" stroke="none"/>
            <circle cx="7" cy="7" r="5.5" fill="none"/>
          </g>
        </svg>
        <p>
          ${translateText(i18n, 'erdgasversorgung')}
        </p>
      </div>
      <div class="spacer"></div>
      <div class="item">
        <svg viewBox="0 0 20 20" width="20">
          <path d="M6416.334,8895.667V8885H6413l6-8,6,8h-3.333v10.667Z"
                transform="translate(-6409 -8876)"
                fill="#4ac762"/>
        </svg>
        <p>
          ${translateText(i18n, 'einspeisung')}
        </p>
      </div>
      <div class="item">
        <svg viewBox="0 0 20 20" width="20">
          <path
            d="M6421.668,8895.667h-5.333v-1.333h5.333v1.333Zm0-2.667h-5.333v-1.333h5.333V8893Zm0-2.666h-5.333V8889h5.333v1.334Zm0-2.667h-5.333v-1.333h5.333v1.333ZM6425,8885h-12l6-8,6,8Z"
            transform="translate(-6409 -8876)"
            fill="#264d98"/>
        </svg>
        <p>
          ${translateText(i18n, 'transitgas')}
        </p>
      </div>
    `
  }
}

customElements.define('gasmonitoring-schweizerkarte-legende', SchweizerkarteLegende)
